module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/2@2x_9cb53620edec8817e532c85f99dcc1e0.png";